import React, { useEffect, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Box from "@carrier-io/air-react/Box";
import { CircularProgress } from "@carrier-io/air-react";
import { UserContextProvider } from "../contexts/user/userContext";
import { UIUserStatus, UserType } from "../types/user";
import {
  deleteLoginCookies,
  getAccessToken,
  getRefreshToken,
} from "../utils/cookie";
import { RoutesPage } from "../constants/routes";
import { useIAm } from "../hooks/useIAm";

export const ProtectedRoute = () => {
  const { data, loading, error } = useIAm();
  const navigate = useNavigate();

  const shouldRedirectToLogin = useCallback(() => {
    const hasNoTokens = !getAccessToken() && !getRefreshToken();
    const hasNoData = !data;
    const isUserDeactivated = data?.getUser.status === UIUserStatus.INACTIVE;

    return error || (hasNoTokens && hasNoData) || isUserDeactivated;
  }, [data, error]);

  useEffect(() => {
    if (!loading && shouldRedirectToLogin()) {
      deleteLoginCookies(window.location.hostname);
      navigate(RoutesPage.Login, { replace: true });
    }
  }, [data, loading, error, navigate, shouldRedirectToLogin]);

  if (loading || !data || error) {
    return (
      <Box
        position="fixed"
        top="50%"
        left="50%"
        sx={{
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <UserContextProvider user={data?.getUser as UserType}>
      <Outlet />
    </UserContextProvider>
  );
};
